var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"p-5 text-center"},[_vm._v("Overview")]),_c('GoalOverview'),_c('VisionboardOverviewPage'),_c('ChallengeCatalogPage')],1)}
var staticRenderFns = []

export { render, staticRenderFns }